import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import {Injectable, NgZone} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {Logout, ClearStateAndCookies} from '../states/auth/auth.actions';
import {ErrorStatusesEnum} from './auth.interceptor';
import {ErrorService} from '../services/error.service';
import { Router } from '@angular/router';
import { CookiesService } from '../services/cookies.service';
import { TokensEnum } from '../interfaces/TokensEnum';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private store: Store,
    private errorService: ErrorService,
    private router: Router,
    private cookiesService: CookiesService,
    private ngZone: NgZone
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req.clone())
      .pipe(catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {
          let errorMessage;

          switch (error?.status) {
            case ErrorStatusesEnum.AccountUnderReview: {
              this.store.dispatch(new ClearStateAndCookies());
              this.ngZone.run(() => this.router.navigateByUrl('account-under-review'));
              return of(null);
            }
            case ErrorStatusesEnum.InternalServerError:
              errorMessage = 'Internal server error (500)';
              break;
            case ErrorStatusesEnum.Unauthorized:
              // errorMessage = 'Session is expired. Please, login again (401)';
              setTimeout(() => this.store.dispatch(new Logout()));
              break;
            case ErrorStatusesEnum.Integration:
              errorMessage = 'API integration error';
              break;
            case ErrorStatusesEnum.NotFound:
              errorMessage = 'API endpoint not found';
              break;
          }

          if (errorMessage) {
            this.errorService.errorMessage$.next(errorMessage);
          }
        }

        return throwError(error);
      }));
  }
}
